import React from 'react';
import classNames from 'classnames';
import './ToggleArrow.styl';

interface ToggleArrowProps {
  expanded?: boolean;
}

/**
 * Arrow shaped toggle, of the sort you might see in a UI tree component.
 */
const ToggleArrow: React.FC<ToggleArrowProps> = ({expanded}) => {
  return (
    <i
      className={classNames('toggle-arrow', {
        'toggle-arrow-expanded': expanded,
      })}>
      {' '}
    </i>
  );
};

export default ToggleArrow;
